import { ProductOption, productOptionFromResponse } from './ProductOption';
import { TranslatedText } from '../Translation';

interface OptionKeyResponse {
  name: string;
  nameTranslation: TranslatedText;
}

export interface ProductOptionsResponse {
  keys: OptionKeyResponse[];
  options: ProductOption[];
}

export const productOptionsResponseFromResponse = (
  responseData: any,
): ProductOptionsResponse => ({
  keys: (responseData.option_keys ?? []).map((key: any) => ({
    name: key.name,
    nameTranslation: key.name_translation,
  })),
  options: (responseData.option_values ?? []).map((option: any) =>
    productOptionFromResponse(option),
  ),
});
